import React from "react";
import Page from "components/common/page/Page.component";
import StationsListContainer from "containers/management/stations/list/StationsList.container";

const StationsListPage = () => {
    return (
        <Page title="Punti di monitoraggio">
            <StationsListContainer />
        </Page>
    );
};

export default StationsListPage;
